module.exports = __webpack_public_path__ + "img/fourth_door_off.1706cfed.png";